import { useEffect } from 'react';
import { usePageContext } from '@sleepunique/context/PageContext';

const useDisplayNavigation = (display = true) => {
  const { showNavigation, setShowNavigation } = usePageContext();
  useEffect(() => {
    if (showNavigation !== display) setShowNavigation(display);
  });
};

export default useDisplayNavigation;
